import { getProjectImage } from "@/data";
import type { Project } from "@/data";

type Props = {
    project: Project;
    onClick: () => void;
};

const ProjectCard = ({ project, onClick }: Props) => {
  const imageSrc = getProjectImage(project.id);

  return (
        <div
            onClick={onClick}
            className="group bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-56 overflow-hidden bg-gray-50">
            <img
                src={imageSrc}
                alt={project.title}
                className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-300"
            />
          </div>

            <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs font-medium text-[#0D9488]">
                    {project.target}
                  </span>
                    {project.year && (
                        <span className="text-xs text-gray-500">{project.year}</span>
                    )}
                </div>

                <h3 className="text-lg font-bold text-gray-900 mb-3 leading-tight">
                    {project.title}
                </h3>

                <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-2 min-h-[2.75rem]">
                    {project.summary}
                </p>

                <div className="flex flex-wrap gap-2 mb-4">
                    {project.tags.map((tag, index) => (
                        <span
                            key={index}
                            className="px-3 py-1 bg-[#F0FDFA] text-xs font-medium text-[#0F766E] rounded-full"
                        >
                        {tag}
                      </span>
                    ))}
                </div>

                <div className="pt-4 border-t border-gray-100">
                    <p className="text-xs font-medium text-gray-900">
                        성과: {project.result}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ProjectCard;
